import { useState } from "react";

import { ChalkActionButton, SectionTitle } from "../chalk/primitives";
import { SPORT_OPTIONS } from "../../lib/sports";
import { inputStyle } from "./shared";

const lbl = { fontSize: 11, fontWeight: 700, color: "var(--chalk-muted)", display: "flex", flexDirection: "column", gap: 4 };

/** Sport picker + editable sport defaults. `sports` = preset table from the API. */
export default function RulesEditor({ title = "Sport & rules", sport, rules, sports, locked, onSave, testPrefix = "rules", allowInherit }) {
  const [key, setKey] = useState(sport || "");
  const [r, setR] = useState(rules);
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setR((x) => ({ ...x, [k]: v }));
  function pickSport(k) {
    setKey(k);
    const preset = sports?.[k || rules.sport];
    if (preset) setR((x) => ({ ...x, ...preset }));
  }
  async function save() {
    setBusy(true);
    try {
      await onSave({
        sport: key || null,
        rules: {
          score_label: r.score_label, ties_allowed: r.ties_allowed, diff_cap: Number(r.diff_cap),
          duration_min: Number(r.duration_min), location_noun: r.location_noun,
          tie_methods: String(r.tie_methods).split(",").map((s) => s.trim()).filter(Boolean),
          win_pts: Number(r.win_pts), tie_pts: Number(r.tie_pts), loss_pts: Number(r.loss_pts),
        },
      });
    } finally { setBusy(false); }
  }
  const field = (k, label, type = "text") => (
    <label style={lbl}>{label}
      <input type={type} value={Array.isArray(r[k]) ? r[k].join(", ") : r[k] ?? ""} disabled={locked}
             onChange={(e) => set(k, e.target.value)} data-testid={`${testPrefix}-${k}`} style={inputStyle} />
    </label>
  );
  return (
    <div data-testid={`${testPrefix}-editor`} style={{ marginBottom: 14 }}>
      <SectionTitle label={title} />
      <select value={key} disabled={locked} onChange={(e) => pickSport(e.target.value)} data-testid={`${testPrefix}-sport`}
              style={{ ...inputStyle, marginBottom: 8 }}>
        {allowInherit && <option value="">Same as tournament</option>}
        {SPORT_OPTIONS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
      </select>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
        {field("score_label", "Score label")}
        {field("diff_cap", "Point-diff cap (C)", "number")}
        {field("duration_min", "Game length (min)", "number")}
        {field("location_noun", "Location naming")}
        {field("win_pts", "Pts per win", "number")}
        {field("tie_pts", "Pts per tie", "number")}
      </div>
      <div style={{ marginTop: 8 }}>{field("tie_methods", "Tied bracket game decided by (comma list)")}</div>
      <label style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 13, margin: "8px 0" }}>
        <input type="checkbox" checked={!!r.ties_allowed} disabled={locked} onChange={(e) => set("ties_allowed", e.target.checked)}
               data-testid={`${testPrefix}-ties_allowed`} /> Allow ties in pool play
      </label>
      {locked ? (
        <div style={{ fontSize: 11, color: "var(--chalk-muted)" }}>Locked — reset the bracket to change rules.</div>
      ) : (
        <ChalkActionButton label="Save rules" variant="ghost" loading={busy} onClick={save} testId={`${testPrefix}-save`} />
      )}
    </div>
  );
}
